import blogApi from "../../apis/blogApi"
import { getBlogsFail, getBlogsSuccess, isPending } from "./blogSlice"
import { toast } from "react-toastify"

export const fetchBlogsAction = () => async (dispatch) => {
  dispatch(isPending())

  const result = await blogApi.fetchAllBlogs()

  result ? dispatch(getBlogsSuccess(result)) : dispatch(getBlogsFail())
}

export const deleteBlogAction = (_id) => async (dispatch) => {
  dispatch(isPending())

  const result = await blogApi.deleteABlog(_id)

  result.status === 200
    ? dispatch(fetchBlogsAction()) && toast.success(result.message)
    : toast.warn(result.message)
}
